import { authEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiUserHandler } from "@/services/shared";
import type { ApiUserType, AuthUserType } from "@/types";

export const getCurrentUserHandler = async (): Promise<AuthUserType> => {
    const response = await axiosClient.get<{ user: ApiUserType } | ApiUserType>(authEndpoints.me);

    const apiUser = "user" in response.data ? response.data.user : response.data;

    return transformApiUserHandler(apiUser);
};
